<template>
  <m-form
      :title="title"
      :items="items"
      :cols="cols"
      :show-list-btn="false"
      :deletable="item.id"
      list-export-base-url="reports/lists/exportVerifiers"
      :list_filters="{}"
      :exportParams="{id: item.id}"
      :is-editing.sync="isEditing"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
  >
    <template #default>
      <v-row>
        <template v-if="hasParent">
          <v-col cols="12">
            <v-autocomplete
                class="rounded-lg"
                :return-object="false"
                label=" * فرم"
                :items="forms"
                v-model="item.form"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field class="rounded-lg" label="نام" v-model="item.name"/>
          </v-col>
          <v-col cols="12">
            <v-text-field class="rounded-lg" label=" * سمت" v-model="item.post"/>
          </v-col>
        </template>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import {MFormMixin} from "@/components/m-form";

export default {
  mixins: [MFormMixin],
  data() {
    let forms = [
      {text: "سند", value: "s"},
      {text: "دریافت", value: "tr"},
      {text: "پرداخت", value: "tp"},
      {text: "چک", value: "ch"},
      {text: "فاکتور فروش", value: "fs"},
      {text: "فاکتور خرید", value: "fb"},
      {text: "فاکتور برگشت از فروش", value: "fbfs"},
      {text: "فاکتور برگشت از خرید", value: "fbfb"},
      {text: "پیش فاکتور فروش", value: "frb"},
      {text: "پیش فاکتور خرید", value: "pfs"},
      {text: "رسید تعدیل انبار", value: "ia"},
      {text: "حواله تعدیل انبار", value: "oa"},
      {text: "رسید", value: "frc"},
      {text: "حواله", value: "frm"},
      {text: "حواله کالای مصرفی", value: "cwr"},
      {text: "انتقال", value: "t"},
      {text: "انبارگردانی", value: "wh"},
      {text: "اسناد ضمانتی", value: "gt"},
    ];
    return {
      item: {},
      items: [],
      baseUrl: "reports/exportVerifiers",
      appendSlash: true,
      forms: forms,
      cols: [
        {
          text: "فرم",
          value: "form",
          items: forms,
        },
        {
          text: "نام",
          value: "name",
        },
        {
          text: "سمت",
          value: "post",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("تایید کنندگان خروجی");
    },
    hasParent() {
      return this.level != 0;
    },
  },
  methods: {
    getData() {
      this.getVerifiers(true);
    },
    getVerifiers() {
      this.request({
        url: this.endpoint("reports/exportVerifiers/"),
        method: "get",
        success: (data) => {
          this.items = data;
        },
      });
    },
    setItem(item) {
      this.item = item;
    },
    getSerialized() {
      let item = this.extractIds(this.item);
      item.type = this.factorType;
      return item;
    },
  },
};
</script>